import { Box } from "@mui/material";
import React from "react";

const EventStageBar = (props)=> {
    const {statusCode} = props;
    const statusCodes = [1, 2, 3, 4, 5]
    return <Box width='100%' sx={{ height:{xs:'7px',lg:'7px',xl:'13px'}}} className='flex row j-between'>
        {
            statusCodes.map((status, index)=> {
                return <Box key={index} sx={{
                    height: {xs:'7px',lg:'7px',xl:'13px'},
                    width: '19%',
                    backgroundColor: statusCode > index ? '#08231B' : '#EBEBEB',
                    borderBottomLeftRadius: index == 0 && '10px',
                    borderBottomRightRadius: index == statusCodes?.length - 1 && '10px'
                }}>
                </Box>
            })
        }
    </Box>
}
export default EventStageBar